import moment from 'moment';
import { Notify } from 'quasar';
import cloneDeep from 'lodash.clonedeep';

import store from 'src/store';

export async function wait(millis) {
	if (moment.isDuration(millis)) {
		millis = millis.asMilliseconds();
	}
	return new Promise(resolve => setTimeout(resolve, millis));
}

export function getValue(object, key) {
	if (!(object instanceof Object)) return undefined;

	const keys = key instanceof Array ? key : key.split('.');
	key = keys.shift();

	if (keys.length < 1) return object[key];

	return getValue(object[key], keys);
}

export function mapModel(scope, entries) {
	let commitScope = scope.split('.').map((s, i) => {
		if (i < 1) return s;
		return s.replace(/([a-z0-9]|(?=[A-Z]))([A-Z])/g, '$1_$2').toUpperCase();
	});
	if (commitScope.length === 1) commitScope.push(scope.toUpperCase());
	commitScope = `${commitScope.shift()}/UPDATE_${commitScope.join('_')}`;

	return entries.reduce((modelHandlers, entry) => {
		modelHandlers[entry] = {
			get() {
				return getValue(this.$store.state, `${scope}.${entry}`);
			},
			set(value) {
				this.$store.commit(commitScope, { [entry]: value });
			},
		};
		return modelHandlers;
	}, {});
}

export function mapCopy(scope, entries) {
	return entries.reduce((state, entry) => {
		state[entry] = cloneDeep(getValue(store.state, `${scope}.${entry}`) || '');
		return state;
	}, {});
}

export function toListString(obj, clue = ',', encode = v => v) {
	return Object.keys(obj)
		.map(key => `${key}=${encode(obj[key])}`)
		.join(clue);
}

export function authorizeAs24() {
	return new Promise((resolve, reject) => {
		let closeEventChannel = null;
		if (window.BroadcastChannel) {
			closeEventChannel = new BroadcastChannel('MPM_CLOSE_EVENT_CHANNEL');
		}

		const as24AuthWindow = _authorizeAs24();

		let timer;
		const interval = setInterval(() => {
			if (as24AuthWindow.closed) {
				if (!closeEventChannel) {
					resolve();
					return;
				}
				timer = setTimeout(() => {
					reject(new Error('AuthorizationCanceled'));
					clearInterval(interval);
				}, 100);
			}
		}, 500);

		if (closeEventChannel) {
			closeEventChannel.onmessage = () => {
				resolve();
				clearInterval(interval);
				clearTimeout(timer);
			};
		}
	});
}

function _authorizeAs24() {
	/* eslint-disable camelcase */
	const uri = 'https://api.autoscout24.com/auth/oauth/v2/authorize?';

	const uriParams = {
		response_type: 'code',
		client_id: '2e1647c8-9e9c-45fa-acc3-d6f1898312d5',
		redirect_uri: 'https://api.autengo.com/v2/as24Callback',
	};

	const windowFeatures = {
		toolbar: 'no',
		location: 'no',
		status: 'no',
		menubar: 'no',
		scrollbars: 'yes',
		resizable: 'yes',
		left: 760,
		top: 240,
		width: 400,
		height: 600,
		chrome: 'yes',
		centerscreen: 'yes',
		modal: 'yes',
		alwaysRaised: 'yes',
	};

	const as24AuthWindow = window.open(
		uri + toListString(uriParams, '&', encodeURIComponent),
		'targetWindow',
		toListString(windowFeatures),
	);

	if (!as24AuthWindow) {
		Notify.error('Bitte erlauben Sie das Öffnen von POP-UPs und versuchen Sie es erneut!');
		const error = new Error('Can not open a pop-up');
		error.handled = true;
		throw error;
	}

	return as24AuthWindow;
}

export function loadScript(url) {
	return new Promise((resolve, reject) => {
		const head = document.head || document.getElementsByTagName('head')[0];
		const script = document.createElement('script');
		script.async = true;
		script.src = url;
		script.setAttribute('rel', 'preconnect');
		script.charset = 'utf-8';

		head.appendChild(script);

		script.onload = resolve;
		script.onerror = reject;
	});
}

export class Defer {
	constructor() {
		this.promise = new Promise((resolve, reject) => {
			this.resolve = resolve;
			this.reject = reject;
		});
	}
}

export function range(start, end) {
	const range = [];
	for (let i = start; i <= end; i++) {
		range.push(i);
	}
	return range;
}

export function sum(arrayOfObjects, keyToSum) {
	return arrayOfObjects.reduce((sum, obj) => sum + (parseInt(obj[keyToSum]) || 0), 0);
}

export function toChartData(arrayOfObjects, keyToSum, dateKey = 'timestamp') {
	return arrayOfObjects.map(obj => ([obj[dateKey], obj[keyToSum]]));
}
